import * as React from "react";
const SvgNoiseControlOff = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 5,
  fill: "currentColor"
}));
export default SvgNoiseControlOff;